import ViewBase from "../../../../framework/core/mvvm/view_base";
import FirstChargeItem from "./firstcharge_item";


const {ccclass, property} = cc._decorator;

@ccclass
export default class FirstChargeView extends ViewBase {

    @property(cc.Node)
    buyProgress:cc.Node = null;

    @property([cc.Node])
    buyDes:cc.Node[] = [];

    @property(cc.Label)
    buyPrice:cc.Label = null;

    @property(FirstChargeItem)
    firstChargeItems:FirstChargeItem[] = []//0,1,2

    @property([cc.Node])
    preferentials:cc.Node[] = [];

    @property([cc.Node])
    preferentialsGray:cc.Node[] = [];

    updatePanel(data:any){
       this.updateGoodsItem(data);
    }

    //更新商品信息
    updateGoodsItem(data:any){
        let curProgress= data.progress;//标识下个可买商品
        for (let i = 0; i < data.awards.length; i++) {
            let award = data.awards[i];
            if (i<=2) {
                this.firstChargeItems[i].initItem(award,curProgress);
            }
        }

        this.updateProgress(curProgress)//商品进度
        this.updatePreferentials(curProgress);
        this.updateBuyDes(curProgress)
        let award = this.getAward(data.awards,curProgress);
        if (award) {
            this.updateBuyBtnNumb(award.goodsVo.defaultPrice);
        }
    }

    getAward(awards:any[],progress:number){
        for (let i = 0; i < awards.length; i++) {
            let award = awards[i];
            if (award.activityConditionGroup == progress) {
                return award;
            }
        }
        return null;
    }

    //更新购买按钮价格
    updateBuyBtnNumb(price:string){
        this.buyPrice.string = parseInt(price,0).toString();
    }

    //亮起当前可购买的
    updatePreferentials(index:number){
        for (let i = 0; i < this.preferentials.length; i++) {
            let preferentials = this.preferentials[i];
            let preferentialsgray = this.preferentialsGray[i];
            let canLight = (i+1) == index;
            preferentialsgray.active =!canLight
            preferentials.active = canLight;
        }
    }
 
    //更新购买描述
    updateBuyDes(index:number){//1,2,3
        for (let i = 0; i < this.buyDes.length; i++) {
            let buyNode = this.buyDes[i];
            buyNode.active = (index-1 == i);
        }
    }

    updateProgress(index:number){//1,2,3 --进度
        let xPos = 128
        if (index == 2) {
            xPos = 461;
        }else if (index == 3) {
            xPos = 790
        }else if (index == 0) {
            xPos = 0;
        }else if (index == 4) {
            xPos = 889;
        }
        this.buyProgress.setContentSize(new cc.Size(xPos,32))
    }
}
